'use strict';

var $splashIntro = $('.js-splash-intro'),
    $siteHeader,
    $heroCarousel,
    $explorerBar,
    $successes,
    $headerWrapper,
    $stage2Elements,
    stage1Duration,
    stage2Delay,
    stage2Duration,
    stage3Delay,
    stage3Duration;

if (!$splashIntro.length) return;

$siteHeader =  $('.js-site-header');
$heroCarousel = $('.js-hero-carousel');
$explorerBar = $('.js-explorer-bar');
$successes = $('.successes');
$headerWrapper = $('.js-header-wrapper');


$('body').addClass('splash-intro-setup');

stage1Duration = 1200;

stage2Delay = stage1Duration + 500;
stage2Duration = 800;

stage3Delay = stage2Delay + stage2Duration;
stage3Duration = 1000;


$stage2Elements = $siteHeader.add($heroCarousel).add($explorerBar).add($headerWrapper);



$(window).load(function(){

  

  $splashIntro.velocity( "fadeOut", {
  	duration: stage1Duration
  });

  $stage2Elements.velocity( { opacity: 1 }, {
  	duration: stage2Duration,
  	delay: stage2Delay
  });

  $successes.velocity( { translateY: [0, '100%'] }, {
  	duration: stage3Duration,
  	delay: stage3Delay,
  	complete: function(elements) { 
  		$('body').removeClass('splash-intro-setup');
  		$siteHeader.attr('style', '');
  	}
  });
});